module.exports = __webpack_public_path__ + "img/delivery-adress.91fa7288.png";